// src/config/ocr-languages.ts

export interface OcrLanguage {
  code: string;
  label: string;
}

// Data from Tesseract.js documentation for v4.0 trained data
export const AVAILABLE_OCR_LANGUAGES: OcrLanguage[] = [
  { code: 'afr', label: 'Afrikaans' },
  { code: 'amh', label: 'Amharic' },
  { code: 'ara', label: 'Arabic' },
  { code: 'asm', label: 'Assamese' },
  { code: 'aze', label: 'Azerbaijani' },
  { code: 'aze_cyrl', label: 'Azerbaijani - Cyrillic' },
  { code: 'bel', label: 'Belarusian' },
  { code: 'ben', label: 'Bengali' },
  { code: 'bod', label: 'Tibetan' },
  { code: 'bos', label: 'Bosnian' },
  { code: 'bul', label: 'Bulgarian' },
  { code: 'cat', label: 'Catalan; Valencian' },
  { code: 'ceb', label: 'Cebuano' },
  { code: 'ces', label: 'Czech' },
  { code: 'chi_sim', label: 'Chinese - Simplified' },
  { code: 'chi_tra', label: 'Chinese - Traditional' },
  { code: 'chr', label: 'Cherokee' },
  { code: 'cym', label: 'Welsh' },
  { code: 'dan', label: 'Danish' },
  { code: 'deu', label: 'German' },
  { code: 'dzo', label: 'Dzongkha' },
  { code: 'ell', label: 'Greek, Modern (1453-)' },
  { code: 'eng', label: 'English' },
  { code: 'enm', label: 'English, Middle (1100-1500)' },
  { code: 'epo', label: 'Esperanto' },
  { code: 'est', label: 'Estonian' },
  { code: 'eus', label: 'Basque' },
  { code: 'fas', label: 'Persian' },
  { code: 'fin', label: 'Finnish' },
  { code: 'fra', label: 'French' },
  { code: 'frk', label: 'German Fraktur' },
  { code: 'frm', label: 'French, Middle (ca. 1400-1600)' },
  { code: 'gle', label: 'Irish' },
  { code: 'glg', label: 'Galician' },
  { code: 'grc', label: 'Greek, Ancient (-1453)' },
  { code: 'guj', label: 'Gujarati' },
  { code: 'hat', label: 'Haitian; Haitian Creole' },
  { code: 'heb', label: 'Hebrew' },
  { code: 'hin', label: 'Hindi' },
  { code: 'hrv', label: 'Croatian' },
  { code: 'hun', label: 'Hungarian' },
  { code: 'iku', label: 'Inuktitut' },
  { code: 'ind', label: 'Indonesian' },
  { code: 'isl', label: 'Icelandic' },
  { code: 'ita', label: 'Italian' },
  { code: 'ita_old', label: 'Italian - Old' },
  { code: 'jav', label: 'Javanese' },
  { code: 'jpn', label: 'Japanese' },
  { code: 'kan', label: 'Kannada' },
  { code: 'kat', label: 'Georgian' },
  { code: 'kat_old', label: 'Georgian - Old' },
  { code: 'kaz', label: 'Kazakh' },
  { code: 'khm', label: 'Central Khmer' },
  { code: 'kir', label: 'Kirghiz; Kyrgyz' },
  { code: 'kor', label: 'Korean' },
  { code: 'kur', label: 'Kurdish' },
  { code: 'lao', label: 'Lao' },
  { code: 'lat', label: 'Latin' },
  { code: 'lav', label: 'Latvian' },
  { code: 'lit', label: 'Lithuanian' },
  { code: 'mal', label: 'Malayalam' },
  { code: 'mar', label: 'Marathi' },
  { code: 'mkd', label: 'Macedonian' },
  { code: 'mlt', label: 'Maltese' },
  { code: 'msa', label: 'Malay' },
  { code: 'mya', label: 'Burmese' },
  { code: 'nep', label: 'Nepali' },
  { code: 'nld', label: 'Dutch; Flemish' },
  { code: 'nor', label: 'Norwegian' },
  { code: 'ori', label: 'Oriya' },
  { code: 'pan', label: 'Panjabi; Punjabi' },
  { code: 'pol', label: 'Polish' },
  { code: 'por', label: 'Portuguese' },
  { code: 'pus', label: 'Pushto; Pashto' },
  { code: 'ron', label: 'Romanian; Moldavian; Moldovan' },
  { code: 'rus', label: 'Russian' },
  { code: 'san', label: 'Sanskrit' },
  { code: 'sin', label: 'Sinhala; Sinhalese' },
  { code: 'slk', label: 'Slovak' },
  { code: 'slv', label: 'Slovenian' },
  { code: 'spa', label: 'Spanish; Castilian' },
  { code: 'spa_old', label: 'Spanish; Castilian - Old' },
  { code: 'sqi', label: 'Albanian' },
  { code: 'srp', label: 'Serbian' },
  { code: 'srp_latn', label: 'Serbian - Latin' },
  { code: 'swa', label: 'Swahili' },
  { code: 'swe', label: 'Swedish' },
  { code: 'syr', label: 'Syriac' },
  { code: 'tam', label: 'Tamil' },
  { code: 'tel', label: 'Telugu' },
  { code: 'tgk', label: 'Tajik' },
  { code: 'tgl', label: 'Tagalog' },
  { code: 'tha', label: 'Thai' },
  { code: 'tir', label: 'Tigrinya' },
  { code: 'tur', label: 'Turkish' },
  { code: 'uig', label: 'Uighur; Uyghur' },
  { code: 'ukr', label: 'Ukrainian' },
  { code: 'urd', label: 'Urdu' },
  { code: 'uzb', label: 'Uzbek' },
  { code: 'uzb_cyrl', label: 'Uzbek - Cyrillic' },
  { code: 'vie', label: 'Vietnamese' },
  { code: 'yid', label: 'Yiddish' },
];
